// extracted by mini-css-extract-plugin
export var introText = "IntroText-module--intro-text--b2c0a";